import axios from "axios";

const AxiosService = axios.create({
  baseURL: process.env.API_URL + process.env.APP_ENV,
  headers: {
    "Content-Type": "application/json"
  }
});

export default AxiosService;

